import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {SokratesSsoScriptService} from '../services/sokrates-sso-script.service';

/**
 * Pages that need a signed-in account. The session itself is checked by the API (SSO authorizer
 * and Laravel): a rejected request signs in again (AuthInterceptor).
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private ssoScript: SokratesSsoScriptService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (this.authService.current()) {
      return true;
    }

    // Legacy login form while SSO is not enforced.
    if (!this.ssoScript.isEnforced()) {
      return this.router.parseUrl('/login');
    }

    try {
      await this.ssoScript.loginWithRedirect();
    } catch (_) {
      // SSO script gagal load — biarkan halaman error atau user refresh sendiri
    }
    return false;
  }
}
